const toastContainer = document.getElementById('toastContainer');

/** Default time on screen (ms); can override per call. */
const DEFAULT_DISMISS_MS = 5200;

const dismissToast = div => {
  if (!div?.parentNode) {
    return;
  }

  clearTimeout(div._toastDismissId);
  div._toastDismissId = undefined;
  toastContainer.removeChild(div);
};

export const toastAlert = (message = '', type = 'info', dismissMs = DEFAULT_DISMISS_MS) => {
  const types = ['info', 'warning', 'danger'];

  if (!types.includes(type)) {
    type = 'info';
  }

  const template = /* html */`
    ${message}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  `;

  const div = document.createElement('div');
  div.className = `alert alert-${type} alert-dismissible text-break`;
  div.innerHTML = template;

  const btn = div.querySelector('button');
  const close = () => {
    btn.removeEventListener('click', close);
    dismissToast(div);
  };

  btn.addEventListener('click', close);

  toastContainer.appendChild(div);
  setTimeout(() => div.classList.add('show'), 100);

  if (dismissMs > 0) {
    div._toastDismissId = setTimeout(() => dismissToast(div), dismissMs);
  }
};
